module.exports = __webpack_public_path__ + "static/media/BasketBall.a1d98f36.svg";